
import Routing from "../../../assets/outline/Routing.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RoutingIcon({ className, dataTestid = "RoutingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Routing data-testid={dataTestid} className={classes} {...rest} />
  );
}
